"use client";

import { Card, CardContent } from "@/components/ui/card";
import Image from "next/image";
import { ReactNode } from "react";

interface AuthCardProps {
  title: string;
  subtitle: string;
  children?: ReactNode;
}

export function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <Card className="overflow-hidden">
      <CardContent className="grid p-0 md:grid-cols-2">
        <div className="p-6 md:p-8">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col items-center text-center">
              <h1 className="text-2xl tracking-tight">{title}</h1>
              <p className="text-muted-foreground">{subtitle}</p>
            </div>
            {children}
          </div>
        </div>
        <div className="relative hidden items-center justify-center border-l bg-gray-100 md:flex">
          <Image
            src="/logo/axe-logo-black.svg"
            alt="Axe"
            className="dark:brightness-[0.2] dark:grayscale"
            width={200}
            height={80}
          />
        </div>
      </CardContent>
    </Card>
  );
}
